{
  "info": "Informacija",
  "negative": "Klaida",
  "positive": "Sėkmingai"
}
